import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/logo/i-log-logo-transparent.png';
import './Header.css';

function Header({ onInquiry }) {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  useEffect(() => {
    const close = () => setMenuOpen(false);
    window.addEventListener('resize', close);
    return () => window.removeEventListener('resize', close);
  }, []);

  const handleInquiry = () => {
    setMenuOpen(false);
    onInquiry();
  };

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand" aria-label="i-LOG 홈">
          <img src={logo} alt="i-LOG" className="site-header__logo" />
        </Link>

        <nav
          id="site-nav"
          className={`site-header__nav${menuOpen ? ' site-header__nav--open' : ''}`}
          aria-label="주요 메뉴"
        >
          <NavLink to="/privacy" onClick={() => setMenuOpen(false)}>
            개인정보처리방침
          </NavLink>
          <NavLink to="/terms" onClick={() => setMenuOpen(false)}>
            이용약관
          </NavLink>
          <NavLink to="/consent" onClick={() => setMenuOpen(false)}>
            개인정보 수집 동의
          </NavLink>
          <button
            type="button"
            className="site-header__cta site-header__cta--menu"
            onClick={handleInquiry}
          >
            부스 도입 문의
          </button>
        </nav>

        <div className="site-header__actions">
          <button type="button" className="site-header__cta" onClick={handleInquiry}>
            <span className="site-header__cta-full">부스 도입 문의</span>
            <span className="site-header__cta-short">문의</span>
          </button>
          <button
            type="button"
            className={`site-header__menu${menuOpen ? ' is-open' : ''}`}
            onClick={() => setMenuOpen((open) => !open)}
            aria-expanded={menuOpen}
            aria-controls="site-nav"
            aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
      {menuOpen ? (
        <button
          type="button"
          className="site-header__backdrop"
          aria-label="메뉴 닫기"
          onClick={() => setMenuOpen(false)}
        />
      ) : null}
    </header>
  );
}

export default Header;
